"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureFileManager;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _reactRedux = require("react-redux");

var _Auth = require("FileManagerCore/actions/Auth");

var _configureStore = _interopRequireDefault(require("FileManagerLib/utils/redux/configureStore"));

var _withDragDropContext = _interopRequireDefault(require("FileManagerLib/components/withDragDropContext"));

function configureFileManager(_ref) {
  var httpClient = _ref.httpClient,
      _ref$withDragDropCont = _ref.withDragDropContext,
      withDragDropContext = _ref$withDragDropCont === void 0 ? false : _ref$withDragDropCont,
      _ref$withShutterstock = _ref.withShutterstock,
      withShutterstock = _ref$withShutterstock === void 0 ? false : _ref$withShutterstock,
      usageTracker = _ref.usageTracker;
  var store = (0, _configureStore.default)({
    configuration: _immutable.default.Map({
      withShutterstock: withShutterstock
    })
  }, {
    httpClient: httpClient,
    usageTracker: usageTracker
  });

  var FileManager =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2.default)(FileManager, _Component);

    function FileManager() {
      (0, _classCallCheck2.default)(this, FileManager);
      return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FileManager).apply(this, arguments));
    }

    (0, _createClass2.default)(FileManager, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        var auth = this.props.auth;
        store.dispatch((0, _Auth.setAuth)(auth));
      }
    }, {
      key: "render",
      value: function render() {
        var children = this.props.children;
        return _react.default.createElement(_reactRedux.Provider, {
          store: store
        }, children);
      }
    }]);
    return FileManager;
  }(_react.Component);

  FileManager.propTypes = {
    auth: _react.PropTypes.object.isRequired,
    children: _react.PropTypes.node.isRequired
  };
  FileManager.dispatch = store.dispatch;

  if (withDragDropContext) {
    return (0, _withDragDropContext.default)(FileManager);
  }

  return FileManager;
}

module.exports = exports.default;